import {
	Configuration,
	SystemApi,
	UploadApi,
	MergeApi
} from 'orbus-uploader-client';

// import { config as configureEnv } from 'dotenv';
// configureEnv({ path: '../.env' })

export const root = window.location.protocol + '//' + window.location.host;

const basePath = root;
// console.log("CONFIG, process.env:", process.env)
// TODO - for the build, does the below have to be ts - ignored?
const config = new Configuration({
	basePath,
	headers: { 'x-uploader-key': process.env?.REACT_APP_API_KEY || '' }
});
console.log('config value:', config);

export const system = new SystemApi(config);
export const upload = new UploadApi(config);
export const merge = new MergeApi(config);
